import CommitMetadata from "@/components/history/dto/CommitMetadata";


export type ChangeType = "ValueChange" | "ReferenceChange" | "ArrayChange"
    | "ListChange" | "SetChange" | "MultisetChange"
    | "InitialValueChange" | "MapChange" | "NewObject"
    | "ObjectRemoved" | "TerminalValueChange" | ""
export type ElementChangeType = "ValueRemoved" | "ValueAdded" | "ElementValueChange"

export class ElementChange {
    readonly elementChangeType!: ElementChangeType
    readonly index!: number;
    readonly value!: any
    readonly leftValue?: any
    readonly rightValue?: any
}

export class InstanceId {
    readonly cdoId!: unknown
    readonly cdoIdAsString!: string
    readonly typeName!: string
    readonly props!: unknown;

    constructor(init?: Partial<InstanceId>) {
        Object.assign(this, init)
    }
}

export default class Change<T> {
    readonly changeType!: ChangeType;
    readonly globalId!: InstanceId;
    readonly commitMetadata!: CommitMetadata;
    readonly property!: string
    readonly propertyChangeType!: string
    readonly left?: T
    readonly right?: T
}

export class ListChange extends Change<any> {
    readonly elementChanges!: Array<ElementChange>
}